import React from 'react';
import StatementInvoicesList from '../../../components/forms/statement/StatementInvoicesList';

const ReadStatementView: React.FunctionComponent = function () {
    return <StatementInvoicesList displayActions />;
};

export default ReadStatementView;
